export { default as ProductsCategoriesFilterBadge } from './ProductsCategoriesFilterBadge';
